<template>
	<b-modal
	:title="title"
	hide-footer
	id="afip-data-modal">

		<div class="vender-afip-modal__data">
			<div
			class="vender-afip-modal__field"
			v-for="(item, index) in props"
			:key="index">
				<span class="vender-afip-modal__field-label">
					{{ format_afip_label(item.key) }}
				</span>
				<span class="vender-afip-modal__field-value">
					{{ item.value }}
				</span>
			</div>
		</div>

		<hr class="vender-client-block__separator">

		<div
		v-if="client_model"
		class="vender-afip-modal__client-summary">
			<p>
				Nombre en el sistema: {{ client_model.name }}
			</p>
			<p>
				Saldo: {{ price(client_model.saldo_pesos) }}
			</p>
		</div>

		<div class="vender-afip-modal__actions">
			<b-button
			v-if="client_model"
			block
			@click="useClient"
			variant="primary">
				Usar cliente para la venta
			</b-button>

			<btn-loader
			v-else
			:loader="loading"
			id="crear_cliente"
			text="Crear cliente y usar para esta venta"
			@clicked="setCreateClient"></btn-loader>
		</div>

	</b-modal>
</template>
<script>
import price_types from '@/mixins/vender/price_types'
import vender from '@/mixins/vender'
export default {
	mixins: [price_types, vender],
	props: {
		title: String,
		afip_data: Object,
		client_model: Object,
	},
	components: {
		BtnLoader: () => import('@/common-vue/components/BtnLoader'),
	},
	computed: {
		props() {
			if (this.afip_data) {
				return Object.entries(this.afip_data).map(([key, value]) => ({ key, value }));
			}
		},
	},
	data() {
		return {
			loading: false,
		}
	},
	methods: {
		/**
		 * Formatea la clave de un dato AFIP para mostrarla como etiqueta legible.
		 *
		 * @param {string} key Clave del campo devuelto por AFIP.
		 * @returns {string}
		 */
		format_afip_label(key) {
			return key.replaceAll('_', ' ')
		},
		async setCreateClient() {
			this.loading = true
			let location_id = await this.getLocalidad()
			let provincia_id = await this.getProvincia()

			let properties_to_override = [
				{
					key: 'name',
					value: this.afip_data.nombre+' '+this.afip_data.apellido,
				},
				{
					key: 'address',
					value: this.afip_data.direccion,
				},
				{
					key: 'cuit',
					value: this.afip_data.cuit,
				},
				{
					key: 'location_id',
					value: location_id,
				},
				{
					key: 'provincia_id',
					value: provincia_id,
				},
				{
					key: 'iva_condition_id',
					value: this.afip_data.condicion_iva == 'RESPONSABLE INSCRIPTO' ? 1 : this.afip_data.condicion_iva == 'MONOTRIBUTO' ? 2 : 3,
				},
			]

			if (this.afip_data.dni) {
				properties_to_override.push({
					key: 'dni',
					value: this.afip_data.dni,
				})
			}
			this.cerrar()

			this.setModel(null, 'client', properties_to_override, true, false)
			this.loading = false
		},
		getProvincia() {
			if (this.afip_data.provincia) {
				let provincia = this.$store.state.provincia.models.find(provincia => {
					return provincia.name == this.afip_data.provincia
				})

				if (typeof provincia != 'undefined') {
					return provincia.id
				} else {
					return new Promise((resolve, reject) => {
						this.$api.post('provincia', {
							'name': this.afip_data.provincia
						})
						.then(res => {
							this.$store.commit('provincia/add', res.data.model)
							resolve(res.data.model.id)
						})
						.catch(err => {
							console.log(err)
						})
					})
				}
			}
			return null
		},
		getLocalidad() {

			if (this.afip_data.localidad) {

				let localidad = this.$store.state.location.models.find(location => {
					return location.name == this.afip_data.localidad
				})

				if (typeof localidad != 'undefined') {

					return localidad.id

				} else {

					return new Promise((resolve, reject) => {

						this.$api.post('location', {
							'name': this.afip_data.localidad
						})
						.then(res => {
							this.$store.commit('location/add', res.data.model)
							resolve(res.data.model.id)
						})
						.catch(err => {
							console.log(err)
						})

					})

				}
			}

			return null
		},
		useClient() {
			this.$store.commit('vender/setClient', this.client_model)
			this.setPriceType()
			this.cerrar()
		},
		cerrar() {
			this.$bvModal.hide('afip-data-modal')
			let legacy_input = document.getElementById('cuit-para-buscar')
			if (legacy_input) {
				legacy_input.value = ''
			}
		}
	}
}
</script>
<style lang="sass">
@import '@/components/vender/sass/_vender-client-block'
</style>
